export const Hourly = 'hourly'
export const Daily = 'daily'
export const Weekly = 'weekly'
export const Monthly = 'monthly'
export const Options = [
    {
        hide: true,
        value: Hourly,
        label: 'Hourly',
    },
    {
        hide: true,
        value: Daily,
        label: 'Daily'
    },
    {
        hide: true,
        value: Weekly,
        label: 'Weekly'
    },
    {
        hide: true,
        value: Monthly,
        label: 'Monthly',
    }
]